// @flow

import React, { PureComponent } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';
// Helpers
import classNames from 'classnames';
import styles from 'components/PaginationCarousel.scss';

/**
 * PaginationCarousel React component.
 */
class PaginationCarousel extends PureComponent<*, *> {
  /**
   *    Props implementation.
   */
  static propTypes = {
    activeItemIndex: PropTypes.number,
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    handleNext: PropTypes.func,
    numItems: PropTypes.number,
    handlePrevious: PropTypes.func,
    handleItem: PropTypes.func
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> {
    const { activeItemIndex, extendStyle, numItems, handleItem } = this.props;

    const {
      classPaginationCarousel,
      classPaginationCarouselSlideNumber,
      classPaginationCarouselButton,
      classPaginationCarouselActive
    } = styles;

    return (
      <div className={classNames([extendStyle, classPaginationCarousel])}>
        {[...Array(numItems)].map((item, index) => {
          return (
            <button
              id={`PaginationCarousel-item-${index}`}
              key={index}
              className={
                activeItemIndex === index
                  ? classNames(
                      classPaginationCarouselButton,
                      classPaginationCarouselSlideNumber,
                      classPaginationCarouselActive
                    )
                  : classNames(
                      classPaginationCarouselButton,
                      classPaginationCarouselSlideNumber
                    )
              }
              onClick={() => handleItem(index)}
            >
              {index + 1}
            </button>
          );
        })}
      </div>
    );
  }
}

export default PaginationCarousel;



// WEBPACK FOOTER //
// ./src/Common/PaginationCarousel/index.js